import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { Breadcrumb, Tabs } from '../../../../components';
import Items from './Items';

class List extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // selectedTab: 0,
    };
  }

  changeSelectedTab = (/* { index } */) => {
    // this.setState({ selectedTab: index });
  };

  render() {
    const { match } = this.props;
    return (
      <div>
        <Breadcrumb
          title="Campanhas de Mensagens"
          description="Gerencie os pedidos de Campanhas de Mensagens."
        />
        <section className="content-wrapper">
          <Tabs
            sections={[
              { title: 'Todos', path: `${match.url}/todos` },
              { title: 'Hoje', path: `${match.url}/hoje` },
              { title: 'Amanhã', path: `${match.url}/amanha` },
              { title: 'Depois de Amanhã', path: `${match.url}/depois` },
            ]}
          />

          <Route
            path={`${match.url}/todos`}
            component={() => (
              <Items {...this.props} filters="hoje=false&amanha=false&depoisAmanha=false" />
            )}
          />
          <Route
            path={`${match.url}/hoje`}
            component={() => (
              <Items {...this.props} filters="hoje=true&amanha=false&depoisAmanha=false" />
            )}
          />
          <Route
            path={`${match.url}/amanha`}
            component={() => (
              <Items {...this.props} filters="hoje=false&amanha=true&depoisAmanha=false" />
            )}
          />
          <Route
            path={`${match.url}/depois`}
            component={() => (
              <Items {...this.props} filters="hoje=false&amanha=false&depoisAmanha=true" />
            )}
          />
        </section>
      </div>
    );
  }
}

export default List;



// WEBPACK FOOTER //
// ./src/screens/admin/MessagesCampaigns/List/List.js